/**
 * 店铺汇总情况展示
 */

import React from 'react';
import { Row, Col, Statistic, Tooltip, Switch, Select } from 'antd';

import http from '../../../axios/http';
import moment from 'moment';
import { fixedNumber } from '../../../util/util.js';

//铺位情况图
import BerthExhibition from './BerthExhibition';

import './berthSituationStyle.css';
import ContractManageDetail from '../contractManage/ContractManageDetail'
import messager from '../../ui/messager';

class BerthSituationIndex extends React.Component {

    state = {
        summary: {},
        floorList: [],
        exhibition: true,

        queryData: {},
        //建筑信息
        buildingList: [],
        detailVisible: false,
        detailData: {},
    }

    componentDidMount = () => {
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                let buildingList = res == null ? [] : res;
                let buildingId = buildingList[0] == null ? null : buildingList[0]["id"] + "";
                let queryData = { buildingId: buildingId };
                this.setState({ buildingList: buildingList, queryData: queryData });
                //加载铺位信息
                this.loadData(queryData);
            }
        });
    }

    //加载铺位相关信息
    loadData = (queryData) => {
        http.post({
            url: "/berth/findBerthSituation",
            data: queryData,
            success: (res) => {
                let floorList = res["floor"];
                floorList = floorList == null ? [] : floorList;
                let summary = res["summary"];
                this.setState({ floorList: floorList, summary: summary });
                floorList.forEach(item => item["id"] = item["floorId"]);
                //获取到楼层信息后，重新绘制布局图
                this.refs["berthExhibition"].dealFloorData(floorList);
            }
        })
    }

    radioChange = (checked, e) => {
        this.setState({ exhibition: checked });
    }

    selectChange = (field, value, e) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }
    detail = (id) => {
        if (id && id !== undefined && id !== null) {
            http.get({
                url: '/market/contract/query/contractAndBills/' + id,
                success: (res) => {
                    //租金标准
                let rentStandardList = res.rentStandardList;
                if (rentStandardList) {
                    if (rentStandardList !== null && rentStandardList !== undefined) {
                        for (let index in rentStandardList) {
                            rentStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            rentStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                else {
                    rentStandardList = [];
                }
                //物管费标准
                let busiFeeStandardList = [];
                if (res.busiManageContractVO && res.busiManageContractVO.busiFeeStandardList && res.busiManageContractVO.busiFeeStandardList.length > 0) {
                    busiFeeStandardList = res.busiManageContractVO.busiFeeStandardList;
                    if (busiFeeStandardList !== null && busiFeeStandardList !== undefined) {
                        for (let index in busiFeeStandardList) {
                            busiFeeStandardList[index]["rentStartDate"] = moment(rentStandardList[index]["rentStartDate"]);
                            busiFeeStandardList[index]["rentEndDate"] = moment(rentStandardList[index]["rentEndDate"]);
                        }
                    }
                }
                this.state.initDetail(rentStandardList, busiFeeStandardList, res.berthIds, res.freeMonth);
                    this.transferData(res, "partybAccount");
                    this.transferData(res, "partybContactInfo");
                    this.transferData(res, "busiManageContractVO");
                    let allMoney = 0;  //总金额
                    let payCount = 0; // 已付账单次数
                    let payMoney = 0; //已付金额
                    if (res['billList'] !== undefined) {
                        for (let i = 0; i < res['billList'].length; i++) {
                            allMoney += res['billList'][i].totalAmount;
                            if (res['billList'][i].status === '1') {
                                payCount++;
                                payMoney += res['billList'][i].totalAmount
                            }
                        }
                        res.allMoney = allMoney;
                        res.payMoney = payMoney;
                        res.payProportion = ((payCount / res['billList'].length) * 100).toFixed(2);   // 已付账单完成比例
                    }
                    this.setState({ detailData: res, detailVisible: true });
                }
            });
        } else {
            messager.notify("暂无关联合同！");
        }
    }
    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }
    hiddenDetailModal = () => {
        this.setState({ detailVisible: false });
    }
    render() {
        const { summary } = this.state;
        let rate = (summary["floorArea"] === 0 ? 0 : fixedNumber(summary["leasedArea"] * 100 / summary["floorArea"], 2)) + "%";
        let floorNum = this.state.floorList == null ? 0 : this.state.floorList.length;
        return (
            <div className="berth-div">
                <div className="berth-search">
                    <Row>
                        <Col span={20}>
                            <Select onChange={this.selectChange.bind(this, "buildingId")} value={this.state.queryData.buildingId} style={{ width: 200 }}>
                                {this.state.buildingList.map(d =>
                                    <Select.Option key={d["id"]}>{d["buildingName"]}</Select.Option>
                                )}
                            </Select>
                        </Col>
                        <Col span={4} style={{ textAlign: 'right' }}>
                            <Switch checkedChildren="剖面图" unCheckedChildren="情况图" onChange={this.radioChange} defaultChecked />
                        </Col>
                    </Row>
                </div>
                <div className="berth-head" key="hede">
                    <Row>
                        <Col span={3} className="head-statistic">
                            <Statistic title="项目编码" value={this.state.summary["buildingCode"]} />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="楼层数" value={floorNum} />
                        </Col>
                        <Col span={4} className="head-statistic">
                            <Statistic title="铺位总面积" value={this.state.summary["floorArea"]} suffix="㎡" />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="铺位数量" value={this.state.summary["berthNum"]} />
                        </Col>
                        <Col span={4} className="head-statistic">
                            <Statistic title="已出租面积" value={this.state.summary["leasedArea"]} suffix="㎡" />
                        </Col>
                        <Col span={3} className="head-statistic">
                            <Statistic title="已出租铺位数" value={this.state.summary["leasedNum"]} />
                        </Col>
                        <Col span={4} className="head-statistic">
                            <Statistic title="出租率" value={rate} />
                        </Col>
                    </Row>
                </div>
                <div className="berth-content" key="content" style={{ display: (this.state.exhibition ? 'none' : '') }}>
                    {
                        this.state.floorList.map((floor, ind) => {
                            return (
                                <div className="floor-div" key={ind}>
                                    <div className="floor-info">
                                        <span className="floor-name">{floor["floorName"]}</span>
                                        <span>{floor["floorArea"] + "㎡"}</span>
                                    </div>
                                    <div className="floor-berth">
                                        {
                                           
                                            floor["berths"].map((berth, index) => {
                                                let domInfo = (<div>
                                                    <div>{berth["berthCode"]}</div>
                                                    <div>{berth["clientName"]}</div>
                                                    <div>{berth["buildingArea"] + "㎡"}</div>
                                                    <div></div>
                                                </div>);

                                                return (
                                                    <div style={{ width: (berth["buildingArea"] / floor["floorArea"] * 100) + "%" }} key={index} onClick={this.detail.bind(this, berth['contractId'])}>
                                                        <Tooltip title={domInfo}>
                                                            <div className={"berth-info " + (berth.status === 1 ? "booked" : berth.status === 2 ? "leased" : "unuse")}>
                                                                {domInfo}
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="berth-content" key="exhibition" style={{ display: (this.state.exhibition ? '' : 'none') }}>
                    <BerthExhibition ref="berthExhibition" />
                </div>
                <ContractManageDetail
                    successCallback={this.reloadDataFunc}
                    visible={this.state.detailVisible}
                    onCancel={this.hiddenDetailModal.bind(this)}
                    detailData={this.state.detailData}
                    codeList={this.state.codeList}
                    initDetail={(func) => { this.setState({ initDetail: func }) }}
                    type='1'
                />
            </div>
        )
    }
}


export default BerthSituationIndex;